import { filter } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getStringProp } from '@mews/fp';
import { createAsyncActionTypes, createAction, composeProps, createPropsExtender } from '@mews/framework';
import { ApplicationState, CommanderThunkAction } from '@mews-commander/types';
import { Message } from '@mews-commander/messages';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createScopedEntitiesReducer, createScopedBaseEntitySelectors } from './utils';

export const NAME = 'messages';

export const MESSAGES_FETCH = prefix('MESSAGES_FETCH');
export const [MESSAGES_FETCH_STARTED, MESSAGES_FETCH_SUCCEEDED, MESSAGES_FETCH_FAILED] =
    createAsyncActionTypes(MESSAGES_FETCH);

export const [getMessages, getMessagesByIds, getMessageByOwnerId, getMessage] = createScopedBaseEntitySelectors<
    ApplicationState,
    Message,
    typeof NAME,
    'enterpriseId'
>(parentSelector, NAME, 'enterpriseId');

export const getCurrentEnterpriseMessages = composeProps(
    getMessages,
    createPropsExtender('enterpriseId', getCurrentEnterpriseId)
);

export const getCurrentEnterpriseMessagesByThreadId = createSelector(
    getCurrentEnterpriseMessages,
    getStringProp('threadId'),
    (messages, threadId) => filter({ threadId }, messages)
);

export const setMessages =
    (entities: Message[]): CommanderThunkAction =>
    (dispatch) => {
        const enterpriseId = getCurrentEnterpriseId();
        const meta = { scope: enterpriseId };

        return dispatch(createAction(MESSAGES_FETCH_SUCCEEDED, { entities }, meta));
    };

export const messagesReducer = createScopedEntitiesReducer({
    FETCH_SUCCESS: MESSAGES_FETCH_SUCCEEDED,
});
